module.exports = __webpack_public_path__ + "static/media/dynamite.2c78ce3b.gif";